"use client";

import Image from "next/image";
import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import type SwiperCore from "swiper";
import type { HomePackage } from "@/lib/navigation";
import PackageCard from "@/app/(main)/components/PackageCard";

import "swiper/css";
import "swiper/css/navigation";

export default function ArticlePackagesSlider({
  packages,
  destinationName,
}: {
  packages: HomePackage[];
  destinationName?: string;
}) {
  const swiperRef = useRef<SwiperCore | null>(null);

  if (packages.length === 0) return null;

  return (
    <section className="pt-30">
      <div className="title-area text-center mb-30">
        <span className="sub-title">
          {destinationName ? `Explore ${destinationName}` : "Explore More"}
        </span>
        <h2 className="sec-title">Related Packages</h2>
      </div>
      <div className="slider-area tour-slider">
        <Swiper
          className="th-slider has-shadow slider-drag-wrap"
          modules={[Navigation]}
          loop={packages.length > 2}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          spaceBetween={10}
          breakpoints={{
            0: { slidesPerView: 1 },
            576: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 2 },
            1200: { slidesPerView: 2.25 },
          }}
        >
          {packages.map((pack) => (
            <SwiperSlide key={pack.id}>
              <PackageCard pack={pack} />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="icon-box mt-10 text-center">
          <button
            className="slider-arrow style6 default"
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <Image
              src="/main/img/icon/right-arrow2.svg"
              alt="Previous"
              width={24}
              height={24}
            />
          </button>
          <button
            className="slider-arrow style6 default"
            onClick={() => swiperRef.current?.slideNext()}
          >
            <Image
              src="/main/img/icon/left-arrow2.svg"
              alt="Next"
              width={24}
              height={24}
            />
          </button>
        </div>
      </div>
    </section>
  );
}
